module.exports = __webpack_public_path__ + "img/dj.f44a17ab.svg";